import { render, staticRenderFns } from "./BaseSelectLocality.vue?vue&type=template&id=daf52bda&scoped=true"
import script from "./BaseSelectLocality.vue?vue&type=script&lang=js"
export * from "./BaseSelectLocality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf52bda",
  null
  
)

export default component.exports